// extracted by mini-css-extract-plugin
export default {"description":"wtQkzR8OZFgIndrnbC6e"};